<template>
  <page-with-sidebar>
    <page-layout>
      <section slot="header">
        <ul class="tab-list">
          <li v-for="tab in tabList" :key="tab.name">
            <a href="#" :class="{active: tab.name === selectedTab}" @click.prevent="selectTab(tab.name)">{{ tab.title }}</a>
          </li>
        </ul>
      </section>
      <section>
        <tabs v-model="selectedTab" hide-tabs>
          <tab-page name="bill-overview" label="Bills">
            <bills-overview/>
          </tab-page>
          <tab-page name="bill-delivery" label="Delivery">
            <bills-delivery/>
          </tab-page>
          <tab-page name="bill-standing-orders" label="Standing order">
            <bills-standing-orders />
          </tab-page>
        </tabs>
      </section>
    </page-layout>
  </page-with-sidebar>
</template>

<script>

import BillsOverview from '@/components/bills/bills-overview'
import BillsDelivery from '@/components/bills/bills-delivery'
import PageWithSidebar from '@/components/common/main-layout/page-with-sidebar'
import PageLayout from '@/components/common/main-layout/page-layout'
import Tabs from '@/components/common/tabs/tabs'
import TabPage from '@/components/common/tabs/tabPage'
import BillsStandingOrders from '@/components/bills/bills-standing-orders'
import { clearHash, getHashPath } from '@/utils/hashHistoryHandler'
import { lsRemove } from '@/utils/localStorageController'
import { addDataLayerEvent } from '@/services/dataLayer'
import { addUserIdDataLayerEvent } from '@/utils/addUserIdDataLayerEvent'
export default {
  name: 'page-user-bills',
  data () {
    return {
      selectedTab: 'bill-overview',
      tabList: [
        {
          title: this.$t('billsOverview.billsOverviewTitle'),
          name: 'bill-overview'
        },
        {
          title: this.$t('billsDelivery.billsDeliveryTabName'),
          name: 'bill-delivery'
        },
        {
          title: this.$t('standingOrder.standingOrderTabTitle'),
          name: 'bill-standing-orders'
        }
      ]
    }
  },
  components: { BillsStandingOrders, TabPage, Tabs, PageLayout, PageWithSidebar, BillsOverview, BillsDelivery },
  methods: {
    selectTab (tabName) {
      this.selectedTab = tabName
      if (tabName === 'bill-standing-orders') {
        addDataLayerEvent({
          event: 'screen',
          name: 'standing_order'
        })
        addUserIdDataLayerEvent()
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (getHashPath() === 'trajni-nalog') {
        setTimeout(() => {
          this.selectedTab = 'bill-standing-orders'
          lsRemove('sc_standingOrderAddCard')
          addDataLayerEvent('standing-order-view')
          clearHash()
        }, 600)
      }
    })

    addDataLayerEvent({
      event: 'screen',
      name: 'bills'
    })
    addUserIdDataLayerEvent()
  }
}
</script>

<style scoped lang="scss">
.tab-list {
  display: flex;
  margin-bottom: -1.8rem;
  padding-right: 1.6rem;
  overflow-x: auto;

  li {
    margin-right: 2.4rem;

    @media (map_get($breakpoints, sm)) {
      margin-right: 5rem;
    }

    a {
      display: block;
      padding: 1.6rem 0;
      color: $white;
      font-weight: 600;
      text-transform: uppercase;
      text-decoration: none;
      font-size: 1.6rem;
      opacity: 0.5;
      white-space: nowrap;

      &.active {
        box-shadow: inset 0 -3px 0 $white;
        opacity: 1;
      }
    }
  }
}
/*.page-content {
  padding: 2rem 0;
  margin:0 auto;

  @media (map_get($breakpoints, md)) {
    max-width: 960px;
    padding: 0;
  }

  @media (map_get($breakpoints, lg)) {
    max-width: 1240px;
    padding: 0;
  }

  @media (map_get($breakpoints, xxl)) {
    max-width: 1600px;
    padding: 0;
  }
}*/

</style>
